import React, { useEffect } from 'react';
import { Col, Div, Icon, Input, Row, Text } from '@pinpoint/design-kit';

import CONSTANTS from 'src/store/constants';
import { Card, FileDrop, Button } from 'src/components';

import { TopButtons } from './classifier_model';

/* eslint-disable react/prop-types */

function BottomButtons({ onBack }) {
  return (
    <Row>
      <Col size="12">
        <Div m={{ t: '1rem', x: '-0.5rem' }} d="flex" justify="space-between">
          <Button
            buttonStyle="primary"
            m={{ l: '0.5rem' }}
            onClick={() => {
              onBack();
            }}
            data-tip="go back"
            style={{
              flex: '0 0 auto',
            }}
          >
            <Icon color="white" name="LongLeft" size="1rem" m={{ r: '.5em' }} />
            BACK
          </Button>
        </Div>
      </Col>
    </Row>
  );
}

function Reonboarding({
  datasetTag,
  handleFileDrop,
  handleFileSelect,
  files,
  stageFiles,
  progress,
  uploadFileStatus,
  datasetName,
  isAdmin,
  compState,
  triggerDetWorkflowStatus,
  // functions
  getTagStyles,
  uploadFiles,
  setCompState,
  onDone,
  goBack,
}) {
  useEffect(() => {
    if (triggerDetWorkflowStatus === CONSTANTS.API.SUCCEEDED) onDone();
  }, [triggerDetWorkflowStatus, onDone]);

  return (
    <>
      <TopButtons />
      <Row>
        <Col size="12">
          <Card
            title="Select file to upload"
            iconProps={{
              name: 'ClassifierModel',
              color: 'white',
              size: '50px',
              viewBox: '0 0 10 16',
            }}
            titleProps={{
              bg: 'teal',
              h: '88px',
              rounded: '0',
              p: { l: '37px', r: '41.31px' },
              style: {
                borderTopLeftRadius: '8px',
                borderTopRightRadius: '8px',
              },
            }}
            titleTextProps={{
              textColor: 'white',
              style: {
                fontSize: '19px',
                lineHeight: '22.27px',
              },
            }}
            cardProps={{
              rounded: 'sm',
              p: '0',
              style: {
                borderRadius: '8px',
              },
            }}
          >
            <Row p={{ l: '37px', r: '39px', t: '27px', b: '29px' }}>
              <Col size="5">
                <FileDrop
                  onDrop={handleFileDrop}
                  onSelect={handleFileSelect}
                  droppedFiles={files}
                  setDroppedFiles={stageFiles}
                  progress={progress}
                  uploadFileStatus={uploadFileStatus}
                />
              </Col>
              <Col size="7">
                <Text textSize="subtitle" m={{ b: '4px' }}>
                  Dataset Name
                </Text>
                <Input value={datasetName} disabled h="2.4rem" m={{ b: '14px' }} />
                <Text textSize="subtitle" m={{ b: '4px' }}>
                  Type
                </Text>
                <Text textSize="subtitle" m={{ b: '14px' }}>
                  <Div
                    d="flex"
                    align="center"
                    border="1px solid"
                    borderColor="gray500"
                    rounded="md"
                    p={{ x: '12px' }}
                    h="35.2px"
                  >
                    <Icon
                      name="Positive"
                      color="tagHit"
                      viewBox="0 0 50 50"
                      size=".875rem"
                      m={{ r: '.5em' }}
                      alignSelf="center"
                      {...getTagStyles(datasetTag)}
                    />
                    <Text textSize="body" textColor={getTagStyles(datasetTag).color}>
                      {CONSTANTS.SEGMENT.TAG_NAME[datasetTag]}
                    </Text>
                  </Div>
                </Text>
                <Div m={{ t: '40px' }} d="flex" justify="flex-end">
                  <Button
                    buttonStyle="primary"
                    m={{ r: '0rem' }}
                    isLoading={compState !== CONSTANTS.COMPONENT.VALIDATION.VALIDATED}
                    disabled={
                      !isAdmin ||
                      uploadFileStatus === CONSTANTS.API.STARTED ||
                      triggerDetWorkflowStatus === CONSTANTS.API.STARTED ||
                      files.length === 0 ||
                      !datasetName ||
                      compState !== CONSTANTS.COMPONENT.VALIDATION.VALIDATED
                    }
                    loading={uploadFileStatus === CONSTANTS.API.STARTED}
                    onClick={() => {
                      setCompState(CONSTANTS.COMPONENT.OPERATION.STARTED);
                      uploadFiles(files, CONSTANTS.S3_PREFIX.ONPOINT_WORKFLOW);
                    }}
                  >
                    UPLOAD
                    <Icon name="UploadForward" viewBox="0 0 14 16" color="white" m={{ l: '0.5rem' }} size="0.875rem" />
                  </Button>
                </Div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
      <BottomButtons
        onBack={() => {
          goBack();
        }}
      />
    </>
  );
}

export default Reonboarding;
